import {
  SHOP_MANAGER_LIST_SEARCH,
  SHOP_MANAGER_LIST_SEARCH_FAILURE,
  SHOP_MANAGER_LIST_SEARCH_SUCCESS
} from './mutation-types'

export default {
  state: {
    shopManagers: [],
    shopManagerListNextPage: null,
    shopManagerListCurrentPage: null
  },
  getters: {
    shopManagers: state => {
      return state.shopManagers
    },
    shopManagerListNextPage: state => {
      return state.shopManagerListNextPage
    },
    shopManagerListCurrentPage: state => {
      return state.shopManagerListCurrentPage
    }
  },
  actions: {
    [SHOP_MANAGER_LIST_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/master/shop_managers'
      var callback = () => {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SHOP_MANAGER_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(SHOP_MANAGER_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [SHOP_MANAGER_LIST_SEARCH_FAILURE] (state, params) {
      console.log('SHOP_MANAGER_LIST_SEARCH_FAILURE')
    },
    [SHOP_MANAGER_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('SHOP_MANAGER_LIST_SEARCH_SUCCESS')
      var data = params.data
      if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
        state.shopManagers = state.shopManagers.concat(data.data)
        state.shopManagerListCurrentPage = data.meta['current-page']
      } else {
        state.shopManagers = data.data
        state.shopManagerListCurrentPage = 1
      }
      if (data.links && data.links['next']) {
        state.shopManagerListNextPage = data.links['next']
      } else {
        state.shopManagerListNextPage = null
      }
      if (params.callback) {
        params.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shop-manager-list.js